import { FIVE_SECONDS } from "@walletconnect/time";

export const HEARTBEAT_INTERVAL = FIVE_SECONDS;

export const HEARTBEAT_EVENTS = {
  pulse: "heartbeat_pulse",
};
